import { Pipe, PipeTransform } from '@angular/core';
import { AnomalySeverity, DashboardDevice, SubscriptionPlan } from '@vi-iot/client';
import { PillType } from '../../../../shared/components/pill/pill.model';
import { TranslateService } from '@ngx-translate/core';
import { RemoteServiceMapper } from 'src/app/@store/remote-service/remote-service.mapper';
import { DashboardAnomalyPillHelper } from './dashboard-anomaly-pill.helper';

@Pipe({
  name: 'dashboardAnomalyPill',
  standalone: true,
})
export class DashboardAnomalyPillPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(
    device: DashboardDevice,
    quickView?: boolean
  ): DashboardAnomalyPillHelper.AnomalyPill[] | undefined {
    if (device?.plans.includes(SubscriptionPlan.Pro)) {
      if (device.anomalies.length) {
        // Display descriptive label
        if (quickView) {
          if (device.anomalies.length) {
            const isWarningAnomaly = device.anomalies.some(
              (anomaly) =>
                anomaly.severity === AnomalySeverity.Warning ||
                anomaly.severity === AnomalySeverity.Critical
            );

            return [
              {
                pillType: isWarningAnomaly ? PillType.mediumInverted : PillType.infoInverted,
                label: this.translateService.instant(
                  '+REMOTE_INSPECTION.DASHBOARD_ANOMALY_DETECTED'
                ),
              },
            ];
          }
        } else {
          // Display error codes
          const pills: DashboardAnomalyPillHelper.AnomalyPill[] = [];

          const sortedAnomalies = device.anomalies.sort(
            (a, b) =>
              DashboardAnomalyPillHelper.AnomalySeveritySortValue[a.severity] -
              DashboardAnomalyPillHelper.AnomalySeveritySortValue[b.severity]
          );

          sortedAnomalies.forEach((anomaly, index) => {
            // default anomaly color
            const pillType = DashboardAnomalyPillHelper.getAnomalyPillType(anomaly);
            if (index < 3) {
              pills.push({
                pillType,
                label: RemoteServiceMapper.formatDiagnosisId(anomaly.id),
              });
            } else if (index === 3) {
              pills.push({
                pillType,
                label: '...',
                tooltipText: this.translateService.instant(
                  '+INSTALLATIONS.INSTALLATIONS.ANOMALIES.TOOLTIP_SHOW_MORE'
                ),
              });
            } else {
              // Do not display more than 3 codes
              return;
            }
          });

          return pills.length ? pills : undefined;
        }
      } else {
        return [
          {
            pillType: PillType.successInverted,
            label: this.translateService.instant('+REMOTE_INSPECTION.DASHBOARD_NO_ANOMALY'),
          },
        ];
      }
    }
  }
}
